import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import ComponentBackButton from "../../../common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton"
import DynamicButton from "../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import GrayHeading from "../../../common/AdminCommonComponents/GrayHeading/GrayHeading"
import DynamicDropdown from "../../../common/AdminCommonComponents/DynamicDropdown/DynamicDropdown"

const AddNewAttribute = ({ setAddNew }) => {
  const toggle = () => setAddNew((prev) => !prev)

  const categoryOptions = [
    { label: 'Option 1', action: () => console.log('option 1') },
    { label: 'Option 2', action: () => console.log('option 2') },
    { label: 'Option 3', action: () => console.log('option 3') },
  ]

  const attributeTypeOptions = [
    { label: 'Option 1', action: () => console.log('option 1') },
    { label: 'Option 2', action: () => console.log('option 2') },
    { label: 'Option 3', action: () => console.log('option 3') },
  ]
  
  const subCategoryOptions = [
    { label: 'Option 1', action: () => console.log('option 1') },
    { label: 'Option 2', action: () => console.log('option 2') },
    { label: 'Option 3', action: () => console.log('option 3') },
  ]

  const statusOptions = [
    { label: 'Active', action: () => console.log('Active') },
    { label: 'Inactive', action: () => console.log('Inactive') },
  ]

  return (
    <div>
      <ComponentBackButton onClick={toggle} />
      <div className="d-flex justify-content-center">
        <GrayHeading>Add new Attribute</GrayHeading>
      </div>

      <Form className="mt-3" onSubmit={(e) => e.preventDefault()}>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-semibold" for="attributeName">Attribute Name</Label>
              <Input id="attributeName" name="attributeName" placeholder="Name" type="text" />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-semibold" for="attributeType">Attribute Type</Label>
              <DynamicDropdown options={attributeTypeOptions} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-semibold" for="category">Category</Label>
              <DynamicDropdown options={categoryOptions}/>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-semibold" for="attributeType">Sub Categories</Label>
              <DynamicDropdown options={subCategoryOptions}/>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-semibold" for="category">Values</Label>
              <Input placeholder="Value" type="text" />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-semibold" for="attributeType">Status</Label>
              <DynamicDropdown options={statusOptions}/>
            </FormGroup>
          </Col>
        </Row>

        <div className="d-flex justify-content-center my-3">
          <DynamicButton theme="blue">Submit</DynamicButton>
        </div>
      </Form>
    </div>
  )
}

export default AddNewAttribute
